// extracted by mini-css-extract-plugin
export default {"lost":"BoxContainer_lost__kBy1X","boxRow":"BoxContainer_boxRow__kcpG7"};